import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { LocaleProvider } from './lib/i18n';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Non se atopou o elemento raíz');

createRoot(root).render(
  <StrictMode>
    <LocaleProvider><App /></LocaleProvider>
  </StrictMode>,
);
